import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation, useQueryClient } from '@tanstack/vue-query'

export const useSendForm = () => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (data: any) => http.put(`/user/save-notification`, data),
  })

  const sendForm = async (data: any) => {
    try {
      await mutation.mutateAsync(data)

      addSuccess(trs('itf.saved'))

      await queryClient.invalidateQueries({ queryKey: ['auth'] })
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    sendForm,
  }
}
